import { createAction, createReducer } from '@reduxjs/toolkit';
import { RootState } from 'ducks';
import { injectReducer } from 'ducks/configureStore';
import BillyCornerStabilitySheet from './BillyCornerStabilitySheet';
import { Feature, RenderLocation, RendersComponent } from 'features/Feature';

interface BillyCornerStabilityState {
  isStabilitySheetVisible: boolean;
}

const initialState: BillyCornerStabilityState = {
  isStabilitySheetVisible: false
};

type ExtendedRootState = RootState & {
  billyCornerStability?: BillyCornerStabilityState;
};

export const showBillyCornerStabilitySheet = createAction(
  'billyCornerStability/showBillyCornerStabilitySheet'
);
export const hideBillyCornerStabilitySheet = createAction(
  'billyCornerStability/hideBillyCornerStabilitySheet'
);

export const isModalVisible = (state: ExtendedRootState) =>
  state.billyCornerStability?.isStabilitySheetVisible;

const billyCornerStabilityReducer = createReducer(initialState, builder => {
  builder
    .addCase(showBillyCornerStabilitySheet, state => {
      state.isStabilitySheetVisible = true;
    })
    .addCase(hideBillyCornerStabilitySheet, state => {
      state.isStabilitySheetVisible = false;
    });
});

export class BillyCornerStabilityFeature extends Feature implements RendersComponent {
  protected init(): void {
    injectReducer<BillyCornerStabilityState>('billyCornerStability', billyCornerStabilityReducer);
  }

  render(location: RenderLocation) {
    if (location !== RenderLocation.Root) return;
    return BillyCornerStabilitySheet;
  }
}
